import { Button, Input, Space, Table, TableColumnType, Tag } from "antd";
import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PurchaseReceiptStatus } from "../../enum/common";
import { IPurchaseFilter, IPurchaseReceipt } from "../../models/Purchase";
import { useGetPurchaseReceipt } from "../../query/PurchaseQuery";

const PurchaseReceipt = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<IPurchaseFilter>({
    page: 1,
    limit: 10,
  });
  const { data, isLoading } = useGetPurchaseReceipt(filter);
  // eslint-disable-next-line
  const handleSearchReceipNumber = useCallback(
    debounce((value: string) => {
      setFilter((prev) => ({
        ...prev,
        receiptNumber: value || undefined,
        page: 1,
      }));
    }, 500),
    []
  );
  // eslint-disable-next-line
  const handleSearchPONumber = useCallback(
    debounce((value: string) => {
      setFilter((prev) => ({
        ...prev,
        pONumber: value || undefined,
        page: 1,
      }));
    }, 500),
    []
  );

  const column: TableColumnType<IPurchaseReceipt>[] = [
    {
      title: "Mã đơn nhận",
      dataIndex: "receiptNumber",
      key: "receiptNumber",
      filterDropdown: () => {
        return (
          <div className="p-2">
            <Input
              className="border border-gray-300 rounded-md p-1"
              placeholder="Mã đơn nhận"
              onChange={(e) => handleSearchReceipNumber(e.target.value)}
            />
          </div>
        );
      },
      align: "center",
    },
    {
      title: "Mã yêu cầu",
      dataIndex: "requestNumber",
      key: "requestNumber",
      filterDropdown: () => {
        return (
          <div className="p-2">
            <Input
              className="border border-gray-300 rounded-md p-1"
              placeholder="Mã yêu cầu"
              onChange={(e) => handleSearchPONumber(e.target.value)}
            />
          </div>
        );
      },
      align: "center",
    },
    {
      title: "Ngày nhận",
      dataIndex: "receivedDate",
      key: "receivedDate",
      align: "center",
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      render: (value) => {
        if (value === PurchaseReceiptStatus.DRAFT) {
          return <Tag color="blue">Đã tạo</Tag>;
        } else if (value === PurchaseReceiptStatus.COMPLETED) {
          return <Tag color="green">Đã nhận đủ/Hoàn thành</Tag>;
        } else {
          return <Tag color="red">Đã huỷ</Tag>;
        }
      },
      align: "center",
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
      align: "center",
    },
    {
      title: "Thao tác",
      dataIndex: "action",
      key: "action",
      align: "center",
      render: (_, record) => {
        return (
          <Space>
            <Button
              onClick={() => {
                navigate(`/purchase/receipt/${record.receiptNumber}`);
              }}
              type="link"
            >
              Chi tiết
            </Button>
          </Space>
        );
      },
    },
  ];
  return (
    <div className="p-4">
      <div className="flex">
        <Space className="items-end flex-1">
          <Button
            onClick={() => {
              navigate("/purchase/create-receipt");
            }}
            type="primary"
          >
            Tạo đơn nhận hàng
          </Button>
        </Space>
      </div>
      <Table
        dataSource={data?.data}
        columns={column}
        loading={isLoading}
        className="mt-2"
      />
    </div>
  );
};

export default PurchaseReceipt;
